import { apiUrl } from '../../../settings'

export const getDashboardCountUrl = () => {
  return `${apiUrl}/api/getDashboardCount`
}
